var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('element-wrapper',{attrs:{"element":_vm.element}},[_c('text',{attrs:{"slot":"actual-element","dominant-baseline":"hanging","x":_vm.textX,"y":_vm.textY,"font-family":_vm.fontFamily,"font-size":_vm.fontSize,"fill":_vm.fill},slot:"actual-element"},[_vm._v("\n    "+_vm._s(_vm.content)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-011b23b5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/slide-elements/TextElement.vue
// module id = 234
// module chunks = 0 1